import { isValidElement, FC, Fragment, cloneElement, ReactElement } from 'react';
import classnames from 'classnames';

import { isDefined } from 'utils/type-guards';

import styles from './ProCardLayout.module.scss';

interface SlotProps {
  classes?: string;
  dataTestId?: string;
  /** Used for navigation events onClick of a section */
  onClick?: (event: React.MouseEvent<HTMLDivElement>) => void;
  slotType:
    | 'location'
    | 'avatar'
    | 'proprofile_short'
    | 'userinfo'
    | 'proprofile_extended'
    | 'pricingmenu';
  style?: Record<string, string>;
}
type Props = Omit<SlotProps, 'slotType'>;

export const ClickableSection: FC<{
  children: React.ReactNode;
  onClick: (event: React.MouseEvent) => void;
}> = ({ children, onClick }) => (
  <Fragment>
    {Array.isArray(children)
      ? children
          .filter((child) => isDefined(child) && isValidElement(child))
          .map<React.ReactNode>((child, i) =>
            cloneElement(child as ReactElement<any>, {
              key: i,
              onClick,
              style: { cursor: 'pointer' },
            })
          )
      : null}
  </Fragment>
);
const Slot: FC<SlotProps> = ({ classes, children, onClick, slotType, style }) => (
  // eslint-disable-next-line jsx-a11y/no-static-element-interactions
  <div className={classnames(styles[slotType], classes)} onClick={onClick} style={style}>
    {children}
  </div>
);
const ProCardLayout: FC<Props> = ({ children, classes, dataTestId }) => (
  <article data-test-id={dataTestId} className={classnames(styles.container, classes)}>
    {children}
  </article>
);

export type { Props as ProCardLayoutProps };

export { Slot };
export default ProCardLayout;
